
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 199 150"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#193E7D","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M149.769 91.113h14.359c.45 0 1.301-.072 1.709-.16 2.756-.596 5.051-3.043 5.051-6.375 0-3.336-2.295-5.787-5.051-6.385-.408-.088-1.259-.16-1.709-.16h-14.359v13.08"}}),_c('path',{attrs:{"d":"M162.449.604c-13.701 0-24.803 11.105-24.803 24.803v25.76h35.096c.812 0 1.808.058 2.429.089 7.944.399 13.799 4.48 13.799 11.562 0 5.568-4.002 10.321-11.289 11.391v.281c8.049.559 14.211 4.988 14.211 11.967 0 7.551-6.764 12.404-15.779 12.404h-38.467v50.563h36.377c13.699 0 24.805-11.106 24.805-24.803V.604h-36.379"}}),_c('path',{attrs:{"d":"M169.191 64.61c0-3.276-2.299-5.472-4.994-5.928a11.11 11.11 0 00-1.414-.109h-13.014v12.074h13.014c.472 0 1.16-.066 1.414-.108 2.695-.459 4.994-2.654 4.994-5.929M25.205.604C11.507.604.402 11.709.402 25.407V86.66c6.955 3.371 14.143 5.566 21.457 5.566 8.575 0 13.287-5.236 13.287-12.279V51.168h21.333v28.779c0 11.254-6.91 20.281-30.619 20.281-14.267 0-25.458-3.076-25.458-3.076v52.272H36.78c13.697 0 24.802-11.106 24.802-24.803V.604H25.205m68.621 0c-13.698 0-24.803 11.105-24.803 24.803v32.472c6.285-5.39 17.152-8.76 34.809-7.964 9.451.421 19.476 2.957 19.476 2.957v10.5c-5.016-2.542-11.033-4.897-18.785-5.485-13.398-1.012-21.463 5.539-21.463 17.129 0 11.587 8.065 18.136 21.463 17.119 7.752-.58 13.846-2.998 18.785-5.477v10.496s-10.025 2.535-19.476 2.965c-17.657.793-28.524-2.576-34.809-7.967v57.272h36.379c13.697 0 24.803-11.106 24.803-24.803V.604H93.826"}})])])
          )
        }
      }
    